import React, { useCallback, useEffect, useState } from 'react';
import { getConsent, grantConsent, denyConsent } from '../consent';

// Site-wide consent banner. Shown on first visit (no stored choice) and
// reopened by the footer "Cookie settings" link, which dispatches
// `cookie-consent:open`. Visibility is decided after mount so the server-
// rendered markup (no banner) matches first hydration and there's no flash.
const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === null) setVisible(true);
    const open = () => setVisible(true);
    window.addEventListener('cookie-consent:open', open);
    return () => window.removeEventListener('cookie-consent:open', open);
  }, []);

  const accept = useCallback(() => {
    grantConsent();
    setVisible(false);
  }, []);

  const decline = useCallback(() => {
    // denyConsent may reload the page if analytics had already loaded; hide
    // first so the banner doesn't linger if it doesn't.
    setVisible(false);
    denyConsent();
  }, []);

  if (!visible) return null;

  return (
    <div class="cookie-consent" role="region" aria-label="Cookie consent">
      <div class="cookie-consent-inner">
        <p class="cookie-consent-text">
          We use essential cookies to keep this site working. With your consent
          we also use Google Analytics to understand how the site is used — you
          can change your mind any time. See our <a href="/cookies/">Cookie
          Policy</a>.
        </p>
        <div class="cookie-consent-actions">
          <button
            type="button"
            class="button button-small button-white"
            onClick={decline}
          >
            Decline
          </button>
          <button
            type="button"
            class="button button-small button-blue"
            onClick={accept}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
